export default __webpack_public_path__ + "static/media/RET.07fcdf89.jfif";